export const CALENDAR_DAY_LOAD_PENDING = { data: null, isFailed: false }

export const QA_NAME_CALENDAR_DAY_LOAD_WARNING = 'calendarDayLoadWarning'

export const QA_NAME_CALENDAR_DAY_LOAD_WARNING_LINE =
  'calendarDayLoadWarningLine'
